
import React from 'react';
import { Link } from 'react-router-dom';

const socialLinks = [
  { icon: 'ri-kakao-talk-fill', url: '#', label: '카카오톡' },
  { icon: 'ri-instagram-line', url: '#', label: '인스타그램' },
  { icon: 'ri-youtube-line', url: '#', label: '유튜브' }
];

const footerLinks = [
  {
    title: '서비스',
    links: [
      { label: '제품 검색', url: '/products' },
      { label: '제조업체', url: '/manufacturers' },
      { label: '구매 지원', url: '/buyer-tools' },
      { label: '견적 요청', url: '/buyer-tools' }
    ]
  },
  {
    title: '회사',
    links: [
      { label: '회사 소개', url: '/about' },
      { label: '문의하기', url: '/contact' },
      { label: '입점 안내', url: '/manufacturers' }
    ]
  },
  {
    title: '고객지원',
    links: [
      { label: '자주 묻는 질문', url: '/#faq' },
      { label: '이용 가이드', url: '/buyer-tools' },
      { label: '공지사항', url: '#' }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#3B1E08] to-[#1F0F04] text-white">
      {/* 기업을 모십니다 섹션 */}
      <div className="border-b border-amber-500/15">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="text-center">
            <h3 className="text-3xl font-bold mb-4">기업을 모십니다</h3>
            <p className="text-lg text-amber-100/70 mb-8">
              함께 성장할 우수한 제조업체를 찾고 있습니다
            </p>
            <Link
              to="/manufacturers"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/25"
            >
              <i className="ri-building-line"></i>
              입점 신청하기
            </Link>
          </div>
        </div>
      </div>

      {/* 메인 푸터 */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* 로고 및 소개 */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg">
                <i className="ri-ship-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold">만선허브</span>
            </div>
            <p className="text-amber-100/60 text-sm leading-relaxed">
              전국의 우수한 제조업체와 선주·선장을 직접 연결하는 어선 물품 플랫폼
            </p>
          </div>

          {/* Links Columns */}
          {footerLinks.map((column, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-6 text-amber-100">{column.title}</h3>
              <ul className="space-y-4">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.url}
                      className="text-amber-200/50 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="py-8 border-t border-amber-500/15 mb-8">
          <div className="grid md:grid-cols-3 gap-6 text-amber-200/50 text-sm">
            <div className="flex items-center gap-3">
              <i className="ri-phone-line text-amber-400"></i>
              <span>051-123-4567</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-mail-line text-amber-400"></i>
              <span>contact@manseonhub.com</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-map-pin-line text-amber-400"></i>
              <span>부산광역시 중구 중앙대로 123</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-amber-500/15 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-amber-200/40 text-sm">
            © 2024 만선허브. All rights reserved.
          </p>
          <div className="flex gap-8 text-sm">
            <a
              href="#"
              className="text-amber-200/40 hover:text-amber-400 transition-colors cursor-pointer"
            >
              개인정보처리방침
            </a>
            <a
              href="#"
              className="text-amber-200/40 hover:text-amber-400 transition-colors cursor-pointer"
            >
              이용약관
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              className="text-amber-200/40 hover:text-amber-400 transition-colors cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Web Design
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
